import React, { useEffect, useState } from "react";
import { X, Phone } from "lucide-react";
import { useForm, Controller } from "react-hook-form";
import toast from "react-hot-toast";
import ApiService from "../../services/Api.service";

const AgentAssistServiceModel = ({ isOpen, onClose, serviceToEdit, onSave }) => {
  const [scriptOptions, setScriptOptions] = useState([]);

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      callerid: "",
      service: "",
      script: "",
    },
  });

  // Fetch script options
  const fetchScriptOptions = async () => {
    try {
      const res = await ApiService.getScriptOptions();
      if (res.status === 200) {
        setScriptOptions(res.data || []);
      }
    } catch (error) {
      toast.error("Failed to load script options");
    }
  };

  useEffect(() => {
    fetchScriptOptions();
  }, []);

  // Reset form (Edit / Add)
  useEffect(() => {
    if (serviceToEdit) {
      reset({
        callerid: serviceToEdit.callerid || "",
        service: serviceToEdit.service || "",
        script: serviceToEdit.script || "",
      });
    } else {
      reset({
        callerid: "",
        service: "",
        script: "",
      });
    }
  }, [serviceToEdit, isOpen, reset]);

  // Submit
  const onSubmit = (data) => {
    const payload = {
      callerid: data.callerid.trim(),
      service: data.service.trim(),
      script: data.script,
    };

    onSave(payload);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="add-subparam-overlay">
      <div className="add-subparam-modal">
        
        {/* Header */}
        <div className="add-subparam-header">
          <h3>
            <Phone size={18} style={{ marginRight: "6px" }} />
            {serviceToEdit
              ? "Edit Agent Assist Service"
              : "Add Agent Assist Service"}
          </h3>
          <button onClick={onClose} className="close-btn">
            <X size={20} />
          </button>
        </div>

        {/* Form */}
        <form
          id="agentAssistForm"
          onSubmit={handleSubmit(onSubmit)}
          className="add-subparam-body"
        >
          {/* Caller ID */}
          <label>Caller ID</label>
          <Controller
            name="callerid"
            control={control}
            rules={{ required: "Caller ID is required" }}
            render={({ field }) => (
              <input
                {...field}
                className={`form-control ${
                  errors.callerid ? "error" : ""
                }`}
                placeholder="Enter Caller ID"
              />
            )}
          />
          {errors.callerid && (
            <p className="error-text">{errors.callerid.message}</p>
          )}

          {/* Service Name */}
          <label>Service Name</label>
          <Controller
            name="service"
            control={control}
            rules={{ required: "Service name is required" }}
            render={({ field }) => (
              <input
                {...field}
                className={`form-control ${
                  errors.service ? "error" : ""
                }`}
                placeholder="Enter Service Name"
              />
            )}
          />
          {errors.service && (
            <p className="error-text">{errors.service.message}</p>
          )}

          {/* Script Dropdown */}
          <label>Script</label>
          <Controller
            name="script"
            control={control}
            rules={{ required: "Script is required" }}
            render={({ field }) => (
              <select
                {...field}
                className={`form-control ${
                  errors.script ? "error" : ""
                }`}
              >
                <option value="">Select Script</option>
                {scriptOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            )}
          />
          {errors.script && (
            <p className="error-text">{errors.script.message}</p>
          )}
        </form>

        {/* Footer */}
        <div className="add-subparam-footer">
          <button
            type="button"
            className="popup-cancel-btn"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            type="submit"
            form="agentAssistForm"
            className="popup-add-btn"
          >
            {serviceToEdit ? "Update Service" : "Save Service"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgentAssistServiceModel;